export default {
      id: "chevron-usage",
      viewBox: "0 0 11.565 7.197",
      url: "/dist/svg/" + "sprite.svg#chevron-usage",
      toString: function () {
        return this.url;
      }
    }